import { useNotificationsStore, type Notification } from '@/stores/notifications.store';
import styles from './NotificationsContainer.module.scss';

export function NotificationsContainer() {
  const { notifications, dismiss } = useNotificationsStore();

  return (
    <div className={styles.container}>
      {notifications.map((notification) => (
        <NotificationItem
          key={notification.id}
          notification={notification}
          onDismiss={() => dismiss(notification.id)}
        />
      ))}
    </div>
  );
}

interface NotificationItemProps {
  notification: Notification;
  onDismiss: () => void;
}

function NotificationItem({ notification, onDismiss }: NotificationItemProps) {
  const icons: Record<Notification['type'], string> = {
    success: '✓',
    error: '✕',
    warning: '⚠',
    info: 'ℹ',
  };

  return (
    <div className={`${styles.notification} ${styles[notification.type]}`}>
      <span className={styles.icon}>{icons[notification.type]}</span>
      <span className={styles.message}>{notification.message}</span>
      <button className={styles.dismiss} onClick={onDismiss}>
        ✕
      </button>
    </div>
  );
}
